import { Link } from 'react-router-dom';

import { walletConfigPath, walletConfigProgramFromError } from './walletUtils';

// Si el error de crear/reenviar la tarjeta es porque falta configurar la tarjeta de iPhone,
// muestra el enlace a la pantalla "Tarjeta digital"; si no, no muestra nada.
export const WalletConfigLink = ({ message, onNavigate }: { message: string; onNavigate?: () => void }) => {
    const tipo = walletConfigProgramFromError(message);
    if (!tipo) return null;
    return (
        <Link to={walletConfigPath(tipo)} onClick={onNavigate} className="d-inline-block mt-2 small fw-semibold">
            <i className="bi bi-gear me-1" />Configurar la tarjeta digital de {tipo}
        </Link>
    );
};
